import {ShieldCheckIcon} from '@primer/octicons-react'
import {
  ThemeProvider,
  Hero,
  Grid,
  AnchorNav,
  SectionIntro,
  FAQ,
  FAQGroup,
  Bento,
  Link,
  Box,
  Text,
  River,
  Heading,
  RiverBreakout,
  Stack,
  Card,
  OrderedList,
} from '@primer/react-brand'

export function SecurityIndex() {
  return (
    <ThemeProvider colorMode="dark" className="lp-has-fontSmoothing">
      <section id="hero" className="lp-Hero">
        <Grid>
          <Grid.Column span={12}>
            {/* Make space for header + nav */}
            <div className="lp-Spacer" style={{height: '137px'}} aria-hidden />

            <Hero data-hpc align="center">
              <Hero.Label size="large" leadingVisual={<ShieldCheckIcon />}>
                GitHub Security
              </Hero.Label>
              <Hero.Heading size="1" weight="bold">
                Very secure hero
              </Hero.Heading>
              <Hero.Description>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Hero.Description>
            </Hero>

            <div className="lp-Spacer lp-Spacer--64" aria-hidden />
          </Grid.Column>
        </Grid>

        <Box className="lp-AnchorNav" style={{height: 0}}>
          <AnchorNav hideUntilSticky>
            <AnchorNav.Link href="#section-1">Section 1</AnchorNav.Link>
            <AnchorNav.Link href="#section-2">Section 2</AnchorNav.Link>
            <AnchorNav.Link href="#faq">FAQs</AnchorNav.Link>
            <AnchorNav.Action href="#">Get started</AnchorNav.Action>
          </AnchorNav>
        </Box>
      </section>

      <section id="section-1">
        <div className="lp-Container">
          <div className="lp-Spacer lp-Spacer--72 lp-Spacer--128xl" aria-hidden />

          <SectionIntro fullWidth>
            <SectionIntro.Label size="large">Section 1</SectionIntro.Label>
            <SectionIntro.Heading size="1" weight="bold">
              Heading
            </SectionIntro.Heading>
          </SectionIntro>

          <div className="lp-Spacer lp-Spacer--56 lp-Spacer--88xl" aria-hidden />

          <Bento>
            <Bento.Item columnSpan={{xsmall: 12, medium: 7}} rowSpan={{xsmall: 3, medium: 4}} visualAsBackground>
              <Bento.Content>
                <Bento.Heading as="h3">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Bento.Heading>
              </Bento.Content>
            </Bento.Item>
            <Bento.Item columnSpan={{xsmall: 12, medium: 5}} rowSpan={{xsmall: 3, medium: 4}} visualAsBackground>
              <Bento.Content>
                <Bento.Heading as="h3">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Bento.Heading>
              </Bento.Content>
            </Bento.Item>
            <Bento.Item columnSpan={{xsmall: 12, medium: 5}} rowSpan={{xsmall: 2, medium: 3}} visualAsBackground>
              <Bento.Content>
                <Bento.Heading as="h3">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Bento.Heading>
              </Bento.Content>
            </Bento.Item>
            <Bento.Item columnSpan={{xsmall: 12, medium: 7}} rowSpan={{xsmall: 2, medium: 3}} visualAsBackground>
              <Bento.Content>
                <Bento.Heading as="h3">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Bento.Heading>
              </Bento.Content>
            </Bento.Item>
          </Bento>

          <div className="lp-Spacer lp-Spacer--96 lp-Spacer--152xl" aria-hidden />
        </div>
      </section>

      <section id="section-2" className=" lp-has-raisedBg">
        <div className="lp-Container">
          <div className="lp-Spacer lp-Spacer--72 lp-Spacer--128xl" aria-hidden />

          <SectionIntro fullWidth>
            <SectionIntro.Label size="large">Section 2</SectionIntro.Label>
            <SectionIntro.Heading as="h2" size="1" weight="bold">
              Heading
            </SectionIntro.Heading>
          </SectionIntro>

          <div className="lp-Spacer lp-Spacer--20 lp-Spacer--40xl" aria-hidden />

          <RiverBreakout>
            <RiverBreakout.A11yHeading>RiverBreakout.A11yHeading</RiverBreakout.A11yHeading>
            <RiverBreakout.Content>
              <Text>
                <em>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</em> In sapien sit ullamcorper id. Aliquam
                luctus sed turpis felis nam pulvinar risus elementum.
              </Text>
            </RiverBreakout.Content>
          </RiverBreakout>

          <River align="end">
            <River.Visual>
              <div className="img" />
            </River.Visual>
            <River.Content>
              <Heading as="h3">Heading</Heading>
              <Text>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit ullamcorper id. Aliquam luctus
                sed turpis felis nam pulvinar risus elementum.
              </Text>
              <Link href="#">Call to action</Link>
            </River.Content>
          </River>
          <River>
            <River.Content>
              <Heading as="h3">Heading</Heading>
              <Text>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit ullamcorper id. Aliquam luctus
                sed turpis felis nam pulvinar risus elementum.
              </Text>
              <Link href="#">Call to action</Link>
            </River.Content>
            <River.Visual>
              <div className="img" />
            </River.Visual>
          </River>
          <River align="end">
            <River.Visual>
              <div className="img" />
            </River.Visual>
            <River.Content>
              <Heading as="h3">Heading</Heading>
              <Text>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit ullamcorper id. Aliquam luctus
                sed turpis felis nam pulvinar risus elementum.
              </Text>
              <Link href="#">Call to action</Link>
            </River.Content>
          </River>

          <div className="lp-Spacer lp-Spacer--48 lp-Spacer--104xl" aria-hidden />
        </div>
      </section>

      <section id="resources">
        <div className="lp-Container">
          <div className="lp-Spacer lp-Spacer--72 lp-Spacer--128xl" aria-hidden />

          <SectionIntro fullWidth>
            <SectionIntro.Heading size="3">Heading</SectionIntro.Heading>
          </SectionIntro>

          <div className="lp-Spacer lp-Spacer--40" aria-hidden />

          <Stack
            direction={{narrow: 'vertical', regular: 'horizontal', wide: 'horizontal'}}
            gap="normal"
            padding="none"
          >
            <div className="lp-Resources-card">
              <Card ctaText="Call to action" href="#">
                <Card.Icon icon={<ShieldCheckIcon />} color="purple" hasBackground />
                <Card.Heading>Heading</Card.Heading>
                <Card.Description>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit ullamcorper id. Aliquam luctus
                  sed turpis felis nam pulvinar risus elementum.
                </Card.Description>
              </Card>
            </div>
            <div className="lp-Resources-card">
              <Card ctaText="Call to action" href="#">
                <Card.Icon icon={<ShieldCheckIcon />} color="purple" hasBackground />
                <Card.Heading>Heading</Card.Heading>
                <Card.Description>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit ullamcorper id. Aliquam luctus
                  sed turpis felis nam pulvinar risus elementum.
                </Card.Description>
              </Card>
            </div>
            <div className="lp-Resources-card">
              <Card ctaText="Call to action" href="#">
                <Card.Icon icon={<ShieldCheckIcon />} color="purple" hasBackground />
                <Card.Heading>Heading</Card.Heading>
                <Card.Description>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit ullamcorper id. Aliquam luctus
                  sed turpis felis nam pulvinar risus elementum.
                </Card.Description>
              </Card>
            </div>
          </Stack>

          <div className="lp-Spacer lp-Spacer--96 lp-Spacer--152xl" aria-hidden />
        </div>
      </section>

      <section id="faq" className=" lp-has-raisedBg">
        <div className="lp-Container">
          <div className="lp-Spacer lp-Spacer--96 lp-Spacer--152xl" aria-hidden />

          <FAQGroup>
            <FAQGroup.Heading>
              Frequently asked <br /> questions.
            </FAQGroup.Heading>

            <FAQ>
              <FAQ.Heading>Group 1</FAQ.Heading>
              <FAQ.Item>
                <FAQ.Question>Question 1</FAQ.Question>
                <FAQ.Answer>
                  <p>Answer 1</p>
                </FAQ.Answer>
              </FAQ.Item>
              <FAQ.Item>
                <FAQ.Question>Question 2</FAQ.Question>
                <FAQ.Answer>
                  <p>Answer 2</p>
                </FAQ.Answer>
              </FAQ.Item>
              <FAQ.Item>
                <FAQ.Question>Question 3</FAQ.Question>
                <FAQ.Answer>
                  <p>Answer 3</p>
                </FAQ.Answer>
              </FAQ.Item>
            </FAQ>

            <FAQ>
              <FAQ.Heading>Group 2</FAQ.Heading>
              <FAQ.Item>
                <FAQ.Question>Question 1</FAQ.Question>
                <FAQ.Answer>
                  <p>Answer 1</p>
                </FAQ.Answer>
              </FAQ.Item>
              <FAQ.Item>
                <FAQ.Question>Question 2</FAQ.Question>
                <FAQ.Answer>
                  <p>Answer 2</p>
                </FAQ.Answer>
              </FAQ.Item>
              <FAQ.Item>
                <FAQ.Question>Question 3</FAQ.Question>
                <FAQ.Answer>
                  <p>Answer 3</p>
                </FAQ.Answer>
              </FAQ.Item>
            </FAQ>
          </FAQGroup>

          <div className="lp-Spacer lp-Spacer--96 lp-Spacer--152xl" aria-hidden />
        </div>
      </section>

      <section id="footnotes">
        <div className="lp-Container">
          <div className="lp-Spacer lp-Spacer--96 lp-Spacer--152xl" aria-hidden />

          <OrderedList>
            <OrderedList.Item className="lp-Footnotes-item">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </OrderedList.Item>
            <OrderedList.Item className="lp-Footnotes-item">
              In sapien sit ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus elementum.
            </OrderedList.Item>
            <OrderedList.Item className="lp-Footnotes-item">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </OrderedList.Item>
          </OrderedList>

          <div className="lp-Spacer lp-Spacer--96 lp-Spacer--152xl" aria-hidden />
        </div>
      </section>
    </ThemeProvider>
  )
}

try{ SecurityIndex.displayName ||= 'SecurityIndex' } catch {}